<template>
  <div class="upload-container" :class="{ horizontalstyle: horizontal }">
    <div class="msuploadstyle">
      <file-upload
        v-on="$listeners"
        v-if="!disabled"
        ref="fileUploadRef"
        @showFileList="clickPositive"
        @success="clickPositiveSuccess"
        @error="clickError()"
        :multiple="multiple"
        :limit="limit"
        :size="size"
        sizeInfo="5M"
        :accept="accept"
        :drag="true"
      >
        <div class="container" :style="'width:' + uploadwidth + 'px;'">
          <i class="el-icon-uploadfile"></i>
          <div class="buttonstyle">
            <el-button
              class="zwx-button zwx-button-text-26"
              :disabled="disabled"
            >
              <span class="btnstyle">
                点击或拖拽文件到此处上传
              </span>
            </el-button>
          </div>
          <span class="tipstyle">{{ tip }}</span>
        </div>
      </file-upload>
      <div v-else class="container" :style="'width:' + uploadwidth + 'px;'">
        <i class="el-icon-uploadfile"></i>
        <div class="buttonstyle">
          <el-button class="zwx-button zwx-button-text-26" :disabled="disabled">
            <span class="btnstyle">
              点击或拖拽文件到此处上传
            </span>
          </el-button>
        </div>
        <span class="tipstyle">{{ tip }}</span>
      </div>
    </div>
    <div
      v-if="msForm.fileList && msForm.fileList.length > 0"
      style="margin-left: 12px;"
    >
      <div
        v-for="(item, index) in msForm.fileList"
        :key="item.fileName"
        @mouseenter="mouseenter(index)"
        @mouseleave="mouseleave(index)"
        style="line-height: 32px;width: fit-content;"
      >
        <span>
          <i :class="item.fileIconShow" style="color:#316CF5! important"></i>
          <a
            style="color:#194DFF !important;cursor:pointer;"
            @click="openFilePreview(msForm.fileList, index)"
          >
            {{ item.fileName }}
          </a>
          <span
            v-if="!disabled"
            style="position:relative;top:2px;"
            class="el-upload-list__item check"
            :style="
              item.check
                ? 'margin-left:5px;display:none;'
                : 'margin-left:5px;cursor:pointer'
            "
          >
            <i class="el-icon-upload-success el-icon-circle-check"></i>
          </span>
          <span
            v-if="!disabled"
            style="position:relative;top:2px;"
            class="check"
            :style="
              item.check
                ? 'margin-left:5px;cursor:pointer'
                : 'margin-left:5px;display:none;'
            "
          >
            <i class="el-icon-close" @click="deletionPositive(index)"></i>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileUploadMultiple",
  props: {
    size: {
      type: Number,
      default: 5 * 1024 * 1024
    },
    fileArr: {
      type: Array,
      default: () => []
    },
    uploadwidth: {
      type: Number,
      default: 480
    },
    tip: {
      type: String,
      default: "支持pdf、jpg格式文件，不大于5M"
    },
    accept: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isZoomInPreview: {
      type: Boolean,
      default: false
    },
    ifCanDelete: {
      type: Boolean,
      default: true
    }
  },
  // 定义属性
  data() {
    return {
      menuCode: "",
      api: this.$store.state.api,
      users: this.$store.state.users,
      file: this.$store.state.file,
      uploadRef: "uploadRef_" + this.$system.uuid(),
      iconShow: true,
      showFileList: [],
      downloadurlList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      msForm: {
        fileList: []
      }
    };
  },
  // 方法集合
  methods: {
    // 上传
    generateFilesUid() {
      this.$emit("loading", true);
      let data = {
        folder: this.folder
      };
      this.$system.get(
        this.api + "/systematic/tools/getAnnexUploadUid-1",
        data,
        true,
        true,
        this.generateSuccess,
        this.generateError
      );
    },
    generateSuccess(data) {
      if (data.type === "00") {
        this.$refs.fileUploadRef.submit(data.annexUploadUid);
      } else {
        this.$emit("loading", false);
        this.$system.notify("错误", data.mess, "error");
      }
    },
    generateError(data) {
      this.$emit("loading", false);
      this.$system.notify("错误", data.mess, "error");
    },
    clickPositive(showList) {
      showList.forEach(item => {
        let flag = this.msForm.fileList.some(e => e.fileName == item);
        if (flag) {
          return;
        }
        this.msForm.fileList.push({
          fileName: item,
          fileIconShow: this.$zwxBase.dealfilePrefix(item),
          check: false
        });
      });
      this.generateFilesUid();
    },
    clickPositiveSuccess(fileList) {
      if (
        this.$zwxBase.verifyIsNotBlank(this.msForm.fileList) &&
        this.$zwxBase.verifyIsNotBlank(fileList)
      ) {
        for (let i in this.msForm.fileList) {
          for (let j in fileList) {
            if (this.msForm.fileList[i].fileName === fileList[j].fileName) {
              this.msForm.fileList[i].filePath = fileList[j].filePath;
              this.msForm.fileList[i].fileType = 1;
            }
          }
        }
        this.$emit("getFileList", this.msForm.fileList);
      }
    },
    clickError() {},
    mouseenter(index) {
      this.msForm.fileList[index].check = true;
      this.$forceUpdate();
    },
    mouseleave(index) {
      this.msForm.fileList[index].check = false;
      this.$forceUpdate();
    },
    // 删除文件
    deletionPositive(index) {
      let fileName = this.msForm.fileList[index].fileName;
      let filePath = this.msForm.fileList[index].filePath;
      this.msForm.fileList.splice(index, 1);
      if (this.$zwxBase.verifyIsBlank(filePath)) {
        this.$refs.fileUploadRef.deleteIndex(index);
      }
      let fileList = this.$refs.fileUploadRef.showFileList || [];
      let count = 0;
      fileList.forEach(item => {
        if (fileName === item) {
          count++;
        }
      });
      for (let i = 0; i < count; i++) {
        for (let j in fileList) {
          if (fileName === fileList[j]) {
            this.$refs.fileUploadRef.deleteIndex(j);
            fileList = this.$refs.fileUploadRef.showFileList || [];
            continue;
          }
        }
      }
      this.$emit("getFileList", this.msForm.fileList);
    },
    openFilePreview(fileList, index) {
      let previewFileList = [];
      if (!this.$zwxBase.verifyIsBlank(fileList)) {
        fileList.forEach(file => {
          let item = {
            fileName: file.fileName,
            filePath: file.filePath
          };
          previewFileList.push(item);
        });
        this.$nextTick(function() {
          top.postMessage(
            {
              handlerType: "previewFile",
              params: {
                fileList: previewFileList,
                index
              }
            },
            "*"
          );
        });
      }
    }
  },
  components: {},
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.msForm.fileList = this.fileArr;
  }
};
</script>

<style lang="less" scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  .msuploadstyle {
    // padding-top: 10px;
    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 480px;
      height: 120px;
      background: #f9fbfd;
      border: 1px dashed #dadee2;
      .buttonstyle {
        padding: 12px !important;
        .btnstyle {
          font-size: 14px;
          color: #2a50d7;
        }
      }
      .tipstyle {
        font-size: 14px;
        color: #777f89;
      }
    }
    /deep/.el-upload.el-upload--text,
    /deep/.el-upload-dragger {
      width: 100%;
      height: 120px;
    }
  }
  .liststyle {
    display: flex;
    flex-direction: column;
    width: 480px;
    font-size: 14px;
    :hover {
      // background-color: #dcdddf;
      // border-radius: 2px;
      // box-shadow: 0px 2px 8px 0px rgba(220, 221, 223, 0.5);
    }
    .filelist {
      display: flex;
      align-items: center;
      width: 332px;
      margin-top: 6px;
      padding: 4px 0px;
      &:hover {
        background-color: #f3f5fa;
      }
      .left {
        flex: 1;
        padding-left: 4px;
        display: flex;
        .iconcontainer {
          padding-left: 4px;
          padding-right: 8px;
        }
        .textstyle {
          max-width: 280px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          &:hover {
            color: #506fdd;
            cursor: pointer;
          }
        }
      }
    }
    .errorstyle {
      color: #a7acb3;
      font-size: 12px !important;
      cursor: pointer;
      padding-right: 4px;
    }
  }
}
.horizontalstyle {
  display: flex;
  .liststyle {
    margin-left: 26px;
    .filelist {
      padding: 0px;
      margin: 0px;
    }
  }
}
</style>

<style></style>
